module.exports = __webpack_public_path__ + "static/img/teacher_3.582130d3.png";